<script setup lang="ts"></script>

<template>
  <div class="not-found-outer">404 - Page not found</div>
</template>

<style scoped>
.not-found-outer {
  display: flex;
  flex-direction: column;
}
</style>
